'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var classnames = _interopDefault(require('classnames'));

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".error-module_error__G9VmE {\n    line-height: 20px;\n    height:20px;\n    font-size:10px;\n    font-weight: 600;\n    color: var(--danger-default);\n}";
var e_s = {"error":"error-module_error__G9VmE"};
styleInject(css);

var css$1 = "/* margins-modifiers */\n/* null */\n.space-module_margin_all__remove__pjEUm {\n  margin: 0;\n}\n.space-module_margin_vertical__remove__26Q3T {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.space-module_margin_horizontal__remove__2jw6Y {\n  margin-left: 0;\n  margin-right: 0;\n}\n/* null */\n/* auto */\n.space-module_margin_all__auto__EOWWH {\n  margin: auto;\n}\n.space-module_margin_vertical__auto__3Zj_G {\n  margin-top: auto;\n  margin-bottom: auto;\n}\n.space-module_margin_horizontal__auto__3BDF8 {\n  margin-left: auto;\n  margin-right: auto;\n}\n/* auto */\n/* margins-modifiers */\n/* margin-couple */\n.space-module_margin_all__couple__2w43c {\n  margin: 5px;\n}\n.space-module_margin_top__couple__EsW7t {\n  margin-top: 5px;\n}\n.space-module_margin_bottom__couple__2po2u {\n  margin-bottom: 5px;\n}\n.space-module_margin_right__couple__3Jf7f {\n  margin-right: 5px;\n}\n.space-module_margin_left__couple__1f4AQ {\n  margin-left: 5px;\n}\n.space-module_margin_horizontal__couple__1w43j {\n  margin-left: 5px;\n  margin-right: 5px;\n}\n.space-module_margin_vertical__couple__32NBN {\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n/* margin-couple */\n/* margins-small */\n.space-module_margin_all__small__yBzj2 {\n  margin: 10px;\n}\n.space-module_margin_top__small__1pcg4 {\n  margin-top: 10px;\n}\n.space-module_margin_bottom__small__t-5ei {\n  margin-bottom: 10px;\n}\n.space-module_margin_right__small__29Mbc {\n  margin-right: 10px;\n}\n.space-module_margin_left__small__3MHPg {\n  margin-left: 10px;\n}\n.space-module_margin_horizontal__small__eCWPf {\n  margin-left: 10px;\n  margin-right: 10px;\n}\n.space-module_margin_vertical__small__11HXm {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n/* end:margins-small */\n/* margins-medium */\n.space-module_margin_all__medium__3VHlD {\n  margin: 20px;\n}\n.space-module_margin_top__medium__1uAAR {\n  margin-top: 20px;\n}\n.space-module_margin_bottom__medium__XDFNb {\n  margin-bottom: 20px;\n}\n.space-module_margin_right__medium__1kMAi {\n  margin-right: 20px;\n}\n.space-module_margin_left__medium__2ilXZ {\n  margin-left: 20px;\n}\n.space-module_margin_horizontal__medium__1Stno {\n  margin-left: 20px;\n  margin-right: 20px;\n}\n.space-module_margin_vertical__medium__lf92b {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n/* end:margins-medium */\n/* margins-large */\n.space-module_margin_all__large__2vCf1 {\n  margin: 20px;\n}\n.space-module_margin_top__large__t8TOp {\n  margin-top: 20px;\n}\n.space-module_margin_bottom__large__1zGgn {\n  margin-bottom: 20px;\n}\n.space-module_margin_right__large__1gsjg {\n  margin-right: 20px;\n}\n.space-module_margin_left__large__3d_og {\n  margin-left: 20px;\n}\n.space-module_margin_horizontal__large__2D65F {\n  margin-left: 20px;\n  margin-right: 20px;\n}\n.space-module_margin_vertical__large__2F1Cd {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n/* end:margins-large */\n";
var s_s = {"margin_all__remove":"space-module_margin_all__remove__pjEUm","margin_vertical__remove":"space-module_margin_vertical__remove__26Q3T","margin_horizontal__remove":"space-module_margin_horizontal__remove__2jw6Y","margin_all__auto":"space-module_margin_all__auto__EOWWH","margin_vertical__auto":"space-module_margin_vertical__auto__3Zj_G","margin_horizontal__auto":"space-module_margin_horizontal__auto__3BDF8","margin_all__couple":"space-module_margin_all__couple__2w43c","margin_top__couple":"space-module_margin_top__couple__EsW7t","margin_bottom__couple":"space-module_margin_bottom__couple__2po2u","margin_right__couple":"space-module_margin_right__couple__3Jf7f","margin_left__couple":"space-module_margin_left__couple__1f4AQ","margin_horizontal__couple":"space-module_margin_horizontal__couple__1w43j","margin_vertical__couple":"space-module_margin_vertical__couple__32NBN","margin_all__small":"space-module_margin_all__small__yBzj2","margin_top__small":"space-module_margin_top__small__1pcg4","margin_bottom__small":"space-module_margin_bottom__small__t-5ei","margin_right__small":"space-module_margin_right__small__29Mbc","margin_left__small":"space-module_margin_left__small__3MHPg","margin_horizontal__small":"space-module_margin_horizontal__small__eCWPf","margin_vertical__small":"space-module_margin_vertical__small__11HXm","margin_all__medium":"space-module_margin_all__medium__3VHlD","margin_top__medium":"space-module_margin_top__medium__1uAAR","margin_bottom__medium":"space-module_margin_bottom__medium__XDFNb","margin_right__medium":"space-module_margin_right__medium__1kMAi","margin_left__medium":"space-module_margin_left__medium__2ilXZ","margin_horizontal__medium":"space-module_margin_horizontal__medium__1Stno","margin_vertical__medium":"space-module_margin_vertical__medium__lf92b","margin_all__large":"space-module_margin_all__large__2vCf1","margin_top__large":"space-module_margin_top__large__t8TOp","margin_bottom__large":"space-module_margin_bottom__large__1zGgn","margin_right__large":"space-module_margin_right__large__1gsjg","margin_left__large":"space-module_margin_left__large__3d_og","margin_horizontal__large":"space-module_margin_horizontal__large__2D65F","margin_vertical__large":"space-module_margin_vertical__large__2F1Cd"};
styleInject(css$1);

/**
 * renders Error Text
 * @type carbon
 */
function errorText(props) {
    return (React__default.createElement("div", { className: classnames([e_s.error, s_s.margin_vertical__remove]) },
        React__default.createElement("p", { className: s_s.margin_vertical__remove }, props.text)));
}

var css$2 = ".pulse-module_loader__2EvJ- {\n  width: fit-content;\n  text-align: center;\n}\n\n.pulse-module_background_default__2l3RB {\n  background: var(--primary-default);\n}\n\n\n.pulse-module_background_invert__2WIEc {\n  background: var(--shades-white);\n}\n\n.pulse-module_loader__2EvJ- > div {\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: pulse-module_pulse__39SY_ 1.4s infinite ease-in-out both;\n  animation: pulse-module_pulse__39SY_ 1.4s infinite ease-in-out both;\n}\n  \n.pulse-module_loader__2EvJ- > div:nth-child(1) {\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s;\n}\n\n.pulse-module_loader__2EvJ- > div:nth-child(2) {\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s;\n}\n\n.pulse-module_loader__2EvJ- > div:nth-child(3) {\n  -webkit-animation-delay: -0.08s;\n  animation-delay: -0.08s;\n}\n\n@-webkit-keyframes pulse-module_pulse__39SY_ {\n  0%, 80%, 100% { -webkit-transform: scale(0) }\n  40% { -webkit-transform: scale(1.0) }\n}\n\n@keyframes pulse-module_pulse__39SY_ {\n  0%, 80%, 100% { \n    -webkit-transform: scale(0);\n    transform: scale(0);\n  } 40% { \n    -webkit-transform: scale(1.0);\n    transform: scale(1.0);\n  }\n}\n";
var p_s = {"loader":"pulse-module_loader__2EvJ-","background_default":"pulse-module_background_default__2l3RB","background_invert":"pulse-module_background_invert__2WIEc","pulse":"pulse-module_pulse__39SY_"};
styleInject(css$2);

// keys
var KEY_ESC = 'Escape';
var KEY_ENTER = 'Enter';
var KEY_TAB = 'Tab';
// arrows
var KEY_DOWN = 'ArrowDown';
var KEY_UP = 'ArrowUp';
// event origin
var CLICK = 'click';
var KEYDOWN = 'keydown';
// size
var size;
(function (size) {
    size[size["compact"] = 10] = "compact";
    size[size["small"] = 16] = "small";
    size[size["normal"] = 24] = "normal";
    size[size["large"] = 36] = "large";
})(size || (size = {}));
var width;
(function (width) {
    width[width["small"] = 360] = "small";
    width[width["normal"] = 700] = "normal";
    width[width["large"] = 920] = "large";
})(width || (width = {}));

/**
 * renders pulse loader
 * @type carbon
 */
function pulseLoader(props) {
    var _a;
    var styleProps = (_a = {}, _a[p_s.background_default] = !props.invert, _a[p_s.background_invert] = props.invert, _a);
    var propSize = (size[props.size || 'normal']) / 5;
    return (React__default.createElement("div", { className: classnames([p_s.loader, p_s.pulse]) },
        React__default.createElement("div", { className: classnames('', styleProps), style: { height: propSize, width: propSize } }),
        React__default.createElement("div", { className: classnames(s_s.margin_left__couple, styleProps), style: { height: propSize, width: propSize } }),
        React__default.createElement("div", { className: classnames(s_s.margin_left__couple, styleProps), style: { height: propSize, width: propSize } })));
}

var css$3 = ".spinLoad-module_spinner__2r-CP {\n  margin: 20px auto;\n  -webkit-animation: spinLoad-module_spinner__2r-CP .6s infinite linear;\n  animation: spinLoad-module_spinner__2r-CP .6s infinite linear;\n}\n\n/* Spinner Circle Rotation */\n.spinLoad-module_spinner_circle__3mpLf {\n  margin: 20px auto;\n  border: 3px var(--primary-light) solid;\n  border-top: 3px var(--primary-default) solid;\n  border-radius: 50%;\n  -webkit-animation: spinLoad-module_spinner__2r-CP .6s infinite linear;\n  animation: spinLoad-module_spinner__2r-CP .6s infinite linear;\n}\n\n@keyframes spinLoad-module_spinner__2r-CP {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(359deg);\n  }\n}\n";
styleInject(css$3);

var css$4 = "/* font-weight */\n.fonts-module_font_bold__cDNYV {\n    font-weight: bold;\n}\n.fonts-module_font_normal__2SYtC {\n    font-weight: normal;\n}\n.fonts-module_font_light__1plTG {\n    font-weight: light;\n}\n/* font-weight */\n/* font-size */\n.fonts-module_font_small__2y6Mh {\n    font-size: 14px;\n}\n.fonts-module_font_medium__2Mx64 {\n    font-size: 16px;\n}\n.fonts-module_font_large__3O4B- {\n    font-size: 18px;\n}\n.fonts-module_font_larger__DI6-c {\n    font-size: 22px;\n}\n.fonts-module_font_headder__37oZd {\n    font-size: 26px;\n}\n/* font-size */";
var f_s = {"font_bold":"fonts-module_font_bold__cDNYV","font_normal":"fonts-module_font_normal__2SYtC","font_light":"fonts-module_font_light__1plTG","font_small":"fonts-module_font_small__2y6Mh","font_medium":"fonts-module_font_medium__2Mx64","font_large":"fonts-module_font_large__3O4B-","font_larger":"fonts-module_font_larger__DI6-c","font_headder":"fonts-module_font_headder__37oZd"};
styleInject(css$4);

var css$5 = ".colors-module_text_tone__QTTW8 {\n    color: #333333;\n}\n.colors-module_text_tone__invert__b5rJO {\n    color: #FFFFFF;\n}\n.colors-module_text_disabled__37xTB {\n    opacity: 0.5;\n}\n.colors-module_secondary_text_tone__3zwpC {\n    color: #585858;\n}\n.colors-module_error_tone__3BOBv {\n    color: #D63300;\n    border-color: #D63300 !important;\n}\n";
var c_s = {"text_tone":"colors-module_text_tone__QTTW8","text_tone__invert":"colors-module_text_tone__invert__b5rJO","text_disabled":"colors-module_text_disabled__37xTB","secondary_text_tone":"colors-module_secondary_text_tone__3zwpC","error_tone":"colors-module_error_tone__3BOBv"};
styleInject(css$5);

var css$6 = ".checkBox-module_checkbox__2on4u {\n  padding: 5px 2px;\n  cursor: pointer;\n  border-radius: 6px;\n}\n\n.checkBox-module_checkbox__2on4u:hover {\n  background: var(--primary-light);\n}\n\n.checkBox-module_label__3psj3 {\n  display: flex;\n  padding-left: 0;\n  cursor: pointer;\n  align-items: center;\n}\n\n.checkBox-module_input__3azsB {\n  width: 16px;\n  height: 16px;\n  padding: 0;\n  margin: 0;\n  vertical-align: bottom;\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n  -webkit-appearance: none;\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  background-size: contain;\n  border-radius: 3px;\n  border: 1px solid var(--shades-grey);\n  transition: background, border 0.16s ease-in-out;\n}\n\n.checkBox-module_input__3azsB[type=checkbox]:checked {\n  border: 1px solid var(--primary-default);\n  background-color: var(--primary-default) !important;\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTkgMTYuMTdMNC44MyAxMmwtMS40MiAxLjQxTDkgMTkgMjEgN2wtMS40MS0xLjQxeiIgZmlsbD0iI2ZmZmZmZiIvPjwvc3ZnPg==);\n}\n\n.checkBox-module_input__3azsB[type=checkbox]:focus:not(:disabled) {\n  outline-width: 0;\n  box-shadow: var(--focus-default);\n}\n\n.checkBox-module_input__3azsB[type=checkbox]:disabled {\n  border: 1px solid var(--shades-grey);\n  background-color: var(--shades-smoke) !important;\n}\n\n.checkBox-module_error_tone__3gUvo {\n  box-shadow: 0 0 0 1px var(--error-default);\n}";
styleInject(css$6);

var css$7 = ".input-module_input__z8kiq {\n    border-radius: 6px;\n    border: solid 1px var(--shades-smoke);\n    background-color: var(--shades-white);\n    font-size: 14px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    color: var(--shades-black);\n    display: block;\n    padding: 0 20px;\n    height: 50px;\n    line-height: 50px;\n    width: 100%;\n    box-sizing: border-box;\n    transition: border 0.16s ease-in;\n}\n\n.input-module_input__z8kiq:focus {\n    box-shadow: 0 0 10px 0 rgba(15, 97, 221, 0.2);\n    border: solid 1px var(--primary-default);\n    outline: none;\n}\n\n.input-module_input__z8kiq:disabled {\n    background: var(--shades-whitesmoke);\n}";
var i_s = {"input":"input-module_input__z8kiq"};
styleInject(css$7);

var ariaClick = function (event) { return (event.detail !== 0
    &&
        event.type === CLICK); };
var ariaKeyDown = function (event, keys, shiftKey, ctrlKey) {
    if (shiftKey === void 0) { shiftKey = false; }
    if (ctrlKey === void 0) { ctrlKey = false; }
    return (event.type === KEYDOWN
        &&
            (event.key !== undefined
                &&
                    keys.includes(event.key)
                &&
                    (shiftKey ? event.shiftKey : ctrlKey ? event.ctrlKey : true)));
};

/**
 * renders core input, for label and errors use InputBox
 * @type carbon
 */
function input(props) {
    var _a;
    var inputRef = React.useRef(null);
    var _b = React.useState(props.value), value = _b[0], setValue = _b[1];
    var onChange = function (event) {
        var inputValue = event.target.value;
        setValue(inputValue);
        props.onChange(event, inputValue);
    };
    var onKeyDown = function (event) {
        if (props.onEnter) {
            if (ariaKeyDown(event, [KEY_ENTER])) {
                props.onEnter(event, value);
            }
        }
    };
    if (props.focus && inputRef.current !== null) {
        inputRef.current.focus();
    }
    React.useEffect(function () {
        setValue(props.value);
    }, [props.value]);
    return (React__default.createElement("input", { ref: inputRef, id: props.id, type: props.type, className: classnames([i_s.input, f_s.font_medium], (_a = {},
            _a[c_s.error_tone] = props.invalid,
            _a)), value: value, name: props.name, placeholder: props.placeHolder, required: props.required, disabled: props.disabled, autoFocus: props.autoFocus, onChange: onChange, onKeyDown: onKeyDown, onBlur: props.onBlur, onFocus: props.onFocus, "aria-label": props.label, style: props.style, autoComplete: "off" }));
}

var css$8 = ".iconButton-module_button_icon__3o_2x {\n  cursor: pointer;\n  background: var(--shades-white);\n  border-radius: 100px;\n  width: 46px;\n  height: 46px;\n  display: flex;\n  justify-content: center;\n  border: solid 1px var(--shades-smoke);\n  transition: all 0.16s ease-in-out;\n  outline-width: 0;\n}\n\n.iconButton-module_button_icon__3o_2x:hover {\n  background-color: var(--shades-whiteSmoke);\n}\n\n.iconButton-module_button_icon__3o_2x:focus:not(:disabled) {\n  box-shadow: var(--focus-default);\n}\n\n.iconButton-module_button_icon__3o_2x:disabled,\n.iconButton-module_button_icon__3o_2x.iconButton-module_disabled__3Xhmp {\n  background: var(--shades-smoke);\n  color: var(--shades-grey);\n  border: none;\n}";
var b_s = {"button_icon":"iconButton-module_button_icon__3o_2x","disabled":"iconButton-module_disabled__3Xhmp"};
styleInject(css$8);

function iconButton(props) {
    var _a;
    var onBlur = function () {
        if (props.onBlur) {
            props.onBlur();
        }
    };
    var onFocus = function (event) {
        if (props.onFocus) {
            props.onFocus(event);
        }
    };
    var onClick = function (event) {
        props.onClick(event);
    };
    var propsStyle = {
        width: 26 + size[props.size || 'small'],
        height: 26 + size[props.size || 'small'],
        borderWidth: props.overRideBorder ? 0 : 1,
    };
    return (React__default.createElement("button", { id: props.id, name: props.name, accessKey: props.accessKey, disabled: props.disabled, onClick: onClick, onFocus: onFocus, onBlur: onBlur, className: classnames([b_s.button_icon], (_a = {}, _a[b_s.disabled] = props.disabled, _a)), style: propsStyle, "aria-label": props.ariaLabel, "data-track": props['data-track'] },
        React__default.createElement("img", { src: props.icon, alt: props.name })));
}

var css$9 = ".dropDown-module_dropdown__2YDr7 {\n  box-shadow: 0 0 30px 0 rgba(13, 33, 73, 0.08);\n  background-color: var(--shades-white);\n  border: 1px solid var(--shades-smoke);\n  position: absolute;\n  z-index: 2;\n  overflow-y: scroll;\n  scroll-behavior: auto;\n  width: calc(100% - 2px);\n}";
var dd_s = {"dropdown":"dropDown-module_dropdown__2YDr7"};
styleInject(css$9);

var css$a = ".animation-module_animated__17t6- {\n    -webkit-animation-duration: 0.16s;\n    animation-duration: 0.16s;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both;\n}\n\n.animation-module_fade_in__3rJj5 {\n    -webkit-animation-name: animation-module_fadeIn__1lT7G;\n    animation-name: animation-module_fadeIn__1lT7G;\n}\n\n.animation-module_fade_in__down__1NxpV {\n    -webkit-animation-name: animation-module_fadeInDown__2R8-U;\n    animation-name: animation-module_fadeInDown__2R8-U;\n}\n\n@-webkit-keyframes animation-module_fadeInDown__2R8-U {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -10%, 0);\n        transform: translate3d(0, -10%, 0);\n    }\n    to {\n        opacity: 1;\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0);\n    }\n}\n\n@keyframes animation-module_fadeInDown__2R8-U {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, -10%, 0);\n        transform: translate3d(0, -10%, 0);\n    }\n    to {\n        opacity: 1;\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0);\n    }\n}\n\n@-webkit-keyframes animation-module_fadeIn__1lT7G {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes animation-module_fadeIn__1lT7G {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}";
var a_s = {"animated":"animation-module_animated__17t6-","fade_in":"animation-module_fade_in__3rJj5","fadeIn":"animation-module_fadeIn__1lT7G","fade_in__down":"animation-module_fade_in__down__1NxpV","fadeInDown":"animation-module_fadeInDown__2R8-U"};
styleInject(css$a);

/**
 * dropDown flyer
 * component is position relatively
 * @type carbon
 */
function dropDown(props) {
    return (React__default.createElement("div", { className: classnames([dd_s.dropdown, a_s.animated, a_s.fade_in__down]), style: { left: props.left || 0, top: props.top, maxHeight: props.height || 300 }, ref: props.forwardRef }, props.children));
}

var css$b = ".focusBox-module_focus_block__1Bf5W {\n  cursor: pointer;\n  padding: 10px 20px;\n  transition: background-color, border 0.16s ease-in-out;\n  border: 2px solid transparent;\n  border-radius: 3px;\n  list-style: none;\n  outline-width: 0;\n}\n\n.focusBox-module_interactable__1Sbx_ {\n  cursor: pointer;\n}\n\n.focusBox-module_focus_block__1Bf5W:hover:not(.focusBox-module_selected__Ugo6A),\n.focusBox-module_hilight__3-QmA:not(.focusBox-module_selected__Ugo6A) {\n  background-color: var(--primary-light);\n  border-radius: 3px;\n}\n\n.focusBox-module_focus_block__1Bf5W.focusBox-module_focus__30EJj {\n  border: 2px solid var(--primary-default);\n}\n\n.focusBox-module_focus_block__1Bf5W.focusBox-module_focus__30EJj:hover {\n  border-radius: 0;\n}\n\n.focusBox-module_selected__Ugo6A {\n  background-color: var(--primary-light);\n}";
styleInject(css$b);

var css$c = ".frame-module_fly__31KcC {\n  transform: translateY(-30px) !important;\n  opacity: 1 !important;\n}\n\n.frame-module_overlay__Z6iES {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  transform: translateY(100%);\n  width: 100%;\n  z-index: 10;\n  opacity: 0;\n  transition: opacity .3s, transform .3s;\n  will-change: opacity, transform;\n  pointer-events: none;\n}\n\n.frame-module_sys_offline__2gtxQ {\n  background: var(--shades-cement);\n  box-shadow: 0 0 2px 0 rgba(2,2,2, 0.16);\n  width: 230px;\n  padding: 20px;\n  color: var(--shades-white);\n}\n\n.frame-module_sys_offline__2gtxQ > h4, small {\n  margin: 0 auto;\n}\n\n.frame-module_sys_offline__2gtxQ > small {\n  color: var(--shades-whitesmoke);\n}\n";
styleInject(css$c);

var css$d = "/* display-flex */\n.display-module_display_flex__3qJa2 {\n    display: flex;\n}\n.display-module_display_flex__row__1TDCG {\n    flex-direction: row;\n}\n.display-module_display_flex__row_r__12M4F {\n    flex-direction: row-reverse;\n}\n.display-module_display_flex__column__a5ugv {\n    flex-direction: column;\n}\n.display-module_display_flex__column_r__1Sf8q {\n    flex-direction: column-reverse;\n}\n/* display-flex */\n/* position */\n.display-module_position_relative__3r10b {\n    position: relative;\n}\n.display-module_position_absolute__B4xp2 {\n    position: absolute;\n}\n/* position */\n\n";
var d_s = {"display_flex":"display-module_display_flex__3qJa2","display_flex__row":"display-module_display_flex__row__1TDCG","display_flex__row_r":"display-module_display_flex__row_r__12M4F","display_flex__column":"display-module_display_flex__column__a5ugv","display_flex__column_r":"display-module_display_flex__column_r__1Sf8q","position_relative":"display-module_position_relative__3r10b","position_absolute":"display-module_position_absolute__B4xp2"};
styleInject(css$d);

function row(props) {
    var _a;
    var propsFlex = (props.flexWidth ?
        ((100 / 12) * (props.flexWidth)) + "%"
        :
            'auto');
    var propsWidth = (props.width ?
        props.width
        :
            propsFlex);
    return (React__default.createElement("div", { className: classnames([d_s.display_flex], (_a = {}, _a[d_s.display_flex__row] = !props.reverse, _a[d_s.display_flex__row_r] = props.reverse, _a)), style: {
            maxHeight: props.height || '100%',
            maxWidth: propsWidth,
            width: propsWidth,
            flexWrap: props.flexWrap || 'unset',
            alignContent: props.alignContent || 'stretch',
            alignSelf: props.alignSelf || 'auto',
            justifyContent: props.justifyContent || 'flex-start',
            alignItems: props.alignItems || 'normal',
        } }, props.children));
}

function column(props) {
    var _a;
    var propsFlex = (props.flexHeight ?
        ((100 / 12) * (props.flexHeight)) + "%"
        :
            'auto');
    var propsHeight = (props.height ?
        props.height
        :
            propsFlex);
    return (React__default.createElement("div", { className: classnames([d_s.display_flex], (_a = {}, _a[d_s.display_flex__column] = !props.reverse, _a[d_s.display_flex__column_r] = props.reverse, _a)), style: {
            maxHeight: propsHeight,
            height: propsHeight,
            width: props.width || '100%',
            flexWrap: props.flexWrap || 'unset',
            alignContent: props.alignContent || 'stretch',
            alignSelf: props.alignSelf || 'auto',
            justifyContent: props.justifyContent || 'flex-start',
        } }, props.children));
}

var css$e = ".modalContainer-module_modal_container__1LPFz {\n  align-self: center;\n  justify-self: center;\n  background: var(--shades-white);\n  max-height: 80vh;\n  position: relative;\n  border-radius: 6px;\n  box-shadow: 0 0 1em 1px var(--shades-smoke);\n}\n\n.modalContainer-module_hidden__3zLxD {\n  display: none;\n}";
var mc_s = {"modal_container":"modalContainer-module_modal_container__1LPFz","hidden":"modalContainer-module_hidden__3zLxD"};
styleInject(css$e);

function modalContainer(props) {
    var propWidth = (width[props.width || 'normal']);
    return (React__default.createElement("div", { id: props.id, "aria-labelledby": props.id + "-name", "aria-describedby": props.id + "-description", "aria-modal": "true", role: "dialog", className: mc_s.modal_container, style: { width: propWidth, padding: props.padding || 5 } },
        React__default.createElement("small", { className: mc_s.hidden, id: props.id + "-name", "aria-hidden": true }, props.name),
        React__default.createElement("small", { className: mc_s.hidden, id: props.id + "-description", "aria-hidden": true }, props.description),
        props.children));
}

var css$f = ".href-module_href__3tb7v {\n  border: none;\n  text-decoration: none;  \n  transition: text-decoration 0.3s ease-in-out;\n}\n\n.href-module_text__14siT {\n  color: var(--primary-default);\n  padding: 0 5px;\n  border-radius: 3px;\n  text-decoration: underline;\n}\n\n.href-module_text__14siT:hover {\n  color: var(--primary-default);  \n}\n\n.href-module_href__3tb7v:focus {\n  color: var(--primary-default);\n  box-shadow: var(--focus-default);\n  outline-width: 0;\n}\n";
styleInject(css$f);

// text

var css$g = ".inputBox-module_input_label__3P8ii {\n    font-size: 14px;\n    font-stretch: normal;\n    line-height: 1.5;\n    letter-spacing: normal;\n    color: var(--shades-black);\n}";
var i_s$1 = {"input_label":"inputBox-module_input_label__3P8ii"};
styleInject(css$g);

/**
 * Renders input element with Label, ErrorMessage and Hint
 * @extends Input,ErrorText from carbon
 * @type metal
 */
function inputBox(props) {
    var _a = React.useState(''), validationError = _a[0], setValidationError = _a[1];
    var _b = React.useState(props.value), value = _b[0], setValue = _b[1];
    var onChange = function (event) {
        var inputValue = event.target.value;
        setValue(inputValue);
        props.onChange(event, inputValue);
    };
    var onBlur = function () {
        innerValidations(value);
        if (props.onBlur) {
            props.onBlur();
        }
    };
    var onFocus = function (event) {
        setValidationError('');
        if (props.onFocus) {
            props.onFocus(event);
        }
    };
    var innerValidations = function (inputValue) {
        var error = '';
        if (props.validator) {
            error =
                (inputValue.length > 0 && props.validator(inputValue)) ||
                    (inputValue.length === 0 && props.requiredMessage) ||
                    '';
            setValidationError(error);
        }
        if (inputValue.length === 0 && props.requiredMessage) {
            error = props.requiredMessage;
            setValidationError(error);
        }
        if (props.isInvalid && (props.validator || props.requiredMessage)) {
            props.isInvalid(error.length > 0, props.name);
        }
    };
    React.useEffect(function () {
        setValue(props.value);
    }, [props.value]);
    return (React__default.createElement("div", null,
        React__default.createElement("div", { className: classnames([
                s_s.margin_bottom__couple,
                d_s.display_flex,
                d_s.display_flex__row,
            ]) },
            React__default.createElement("label", { htmlFor: props.id, className: classnames([
                    i_s$1.input_label,
                    f_s.font_bold,
                    f_s.font_small,
                ]) }, props.label),
            props.optional && !props.requiredMessage && (React__default.createElement("span", { id: "o_" + props.id }, "(optional)"))),
        React__default.createElement(input, { id: props.id, type: props.type, value: value, label: props.label, name: props.name, placeHolder: props.placeHolder, required: !!props.requiredMessage, disabled: props.disabled, autoFocus: props.autoFocus, onChange: onChange, onBlur: onBlur, onFocus: onFocus, invalid: (props.error && props.error.length > 0) || validationError.length > 0 }),
        props.hint && (React__default.createElement("small", { id: "h_" + props.id, className: classnames([
                s_s.margin_top__couple,
                c_s.secondary_text_tone,
            ]) }, props.hint)),
        React__default.createElement("div", { id: "em_" + props.id, className: classnames([f_s.font_bold, f_s.font_small]) },
            React__default.createElement(errorText, { text: props.error || validationError }))));
}

var css$h = ".textButton-module_button__1sr_M {\n  background-color: var(--primary-default);\n  line-height: 50px;\n  height: 50px;\n  padding: 0 20px;\n  border: 1px solid var(--primary-default);\n  border-radius: 5px;\n  font-size: 14px;\n  min-width: 120px;\n  font-weight: bold;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: var(--shades-white);\n  cursor: pointer;\n  transition: all 0.16s ease-in-out;\n  outline-width: 0;\n}\n\n.textButton-module_button__1sr_M.textButton-module_invert__3cCrq {\n  background-color: var(--shades-white);\n  color: var(--primary-default);\n  border: 1px solid var(--primary-default);\n}\n\n.textButton-module_button__1sr_M.textButton-module_invert__3cCrq:active {\n  background: var(--primary-light);\n  transition: all 0.3s ease-in-out;\n}\n\n.textButton-module_button__1sr_M.textButton-module_invert__3cCrq:hover {\n  background: var(--primary-light);\n  transition: all 0.3s ease-in-out;\n}\n\n.textButton-module_button__1sr_M:active:not(.textButton-module_invert__3cCrq) {\n  background: var(--primary-default);\n  transition: all 0.3s ease-in-out;\n}\n\n.textButton-module_button__1sr_M.textButton-module_ghost__3lkPW {\n  border: none !important;\n}\n\n.textButton-module_button__1sr_M:hover:not(:disabled):not(.textButton-module_loading__3xmaf):not(.textButton-module_invert__3cCrq) {\n  box-shadow: 0 10px 20px rgba(8, 63, 147, 0.3);\n  transition: all 0.3s ease-in-out;\n  transform: translateY(-2px);\n}\n\n.textButton-module_button__1sr_M:focus:not(:disabled) {\n  box-shadow: var(--focus-default);\n}\n\n.textButton-module_button__1sr_M:disabled,\n.textButton-module_button__1sr_M.textButton-module_disabled__AaxNH {\n  background: var(--shades-smoke);\n  color: var(--shades-grey);\n  border: none;\n}\n\n.textButton-module_button__1sr_M.textButton-module_loading__3xmaf {\n  pointer-events: none;\n  cursor: wait;\n  background: var(--primary-light);\n}";
var tb_s = {"button":"textButton-module_button__1sr_M","invert":"textButton-module_invert__3cCrq","ghost":"textButton-module_ghost__3lkPW","loading":"textButton-module_loading__3xmaf","disabled":"textButton-module_disabled__AaxNH"};
styleInject(css$h);

function textButton(props) {
    var _a;
    var onClick = function (event) {
        props.onClick(event);
    };
    var propStyles = {
        height: size[props.size || 'normal'] + 26,
        padding: "0 " + (size[props.size || 'normal'] - 4) + "px",
        minWidth: props.size === 'compact' ? 36 : 120,
    };
    return (React__default.createElement("button", { id: props.id, className: classnames([tb_s.button, f_s.font_medium, f_s.font_bold], (_a = {},
            _a[tb_s.disabled] = props.disabled,
            _a[tb_s.loading] = props.loading,
            _a[tb_s.invert] = ['inverted', 'ghost'].includes(props.type || ''),
            _a[tb_s.ghost] = props.type === 'ghost',
            _a)), role: props.role || 'button', onClick: onClick, disabled: props.disabled, style: propStyles, "data-track": props['data-track'] }, props.loading ? (React__default.createElement(row, { justifyContent: "center" },
        React__default.createElement(pulseLoader, null))) : (React__default.createElement("span", null, props.text))));
}

var _ref =
/*#__PURE__*/
React__default.createElement("path", {
  fill: "#0D2149",
  fillRule: "nonzero",
  d: "M7.056 0L8 .944l-4 4-4-4L.944 0 4 3.072z"
});

var dropdownSvg = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%228px%22%20height%3D%225px%22%20viewBox%3D%220%200%208%205%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3Eicons%2Fblack%2Fdropdown%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cg%20id%3D%22icons%2Fblack%2Fdropdown%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22expand_more---material%22%20fill%3D%22%230D2149%22%20fill-rule%3D%22nonzero%22%20points%3D%227.056%200%208%200.944%204%204.944%200%200.944%200.944%200%204%203.072%22%3E%3C%2Fpolygon%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var css$i = "/* width */\n.grids-module_width_1__1__3cAkI {\n    width: 100%;\n}\n.grids-module_width_1__2__3TBbd {\n    width: calc(100%/2);\n}\n.grids-module_width_1__3__zM0fW {\n    width: calc(100%/3);\n}\n.grids-module_width_1__4__2axU7 {\n    width: calc(100%/4);\n}\n/* end:width */";
var g_s = {"width_1__1":"grids-module_width_1__1__3cAkI","width_1__2":"grids-module_width_1__2__3TBbd","width_1__3":"grids-module_width_1__3__zM0fW","width_1__4":"grids-module_width_1__4__2axU7"};
styleInject(css$i);

var css$j = ".selectBox-module_select__d7SBw {\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  letter-spacing: normal;\n  color: var(--shades-black);\n  padding:9px;\n  width: 100%;\n  text-align: left;\n  height: 50px;\n  line-height: 50px;\n  border: solid 1px var(--shades-smoke);\n  padding:0 20px;\n  border-radius: 6px;\n  background:white;\n  outline-width: 0;\n  transition: border 0.16s ease-in-out;\n}\n\n.selectBox-module_select__d7SBw[aria-expanded=true] {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  border-bottom: 0;\n  border: solid 1px var(--shades-smoke) !important;\n  box-shadow: none !important;\n}\n\n.selectBox-module_select__d7SBw:focus:not(.selectBox-module_disabled__2ebN-) {\n  box-shadow: 0 0 10px 0 rgba(15, 97, 221, 0.2);\n  border: solid 1px var(--primary-default);\n}\n\n.selectBox-module_icon__84icH {\n  transform: rotate(0deg);\n  transition: all 0.16s ease-in-out;\n}\n\n.selectBox-module_icon__84icH.selectBox-module_open__1mpuW {\n  transform: rotate(180deg);\n}\n\n.selectBox-module_childrens__24Xa8 {\n  width: 100%;\n  overflow-y: scroll;\n}\n\n.selectBox-module_input__3bnj6 {\n    border-radius: 6px;\n    border: solid 1px var(--shades-smoke);\n    background-color: var(--shades-white);\n    font-size: 14px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    color: var(--shades-black);\n    display: block;\n    padding: 0 20px;\n    height: 50px;\n    line-height: 50px;\n    width: 100%;\n    box-sizing: border-box;\n    transition: border 0.16s ease-in;\n}\n\n.selectBox-module_input__3bnj6:focus {\n    box-shadow: 0 0 10px 0 rgba(15, 97, 221, 0.2);\n    border: solid 1px var(--primary-default);\n    outline: none;\n}\n\n.selectBox-module_input__3bnj6:disabled {\n    background: var(--shades-whitesmoke);\n}";
var sb_s = {"select":"selectBox-module_select__d7SBw","disabled":"selectBox-module_disabled__2ebN-","icon":"selectBox-module_icon__84icH","open":"selectBox-module_open__1mpuW","childrens":"selectBox-module_childrens__24Xa8","input":"selectBox-module_input__3bnj6"};
styleInject(css$j);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var defaultTheme = {
    primary: {
        default: '#0f61dd',
        light: '#f3f7fd',
    },
    danger: {
        default: '#f04546',
        light: '#fef5f6',
    },
    success: {
        default: '#15c26b',
        light: '#f3fcf7',
    },
    trigger: {
        default: '#a951ed',
        light: '#faf6fe',
    },
    acknowledge: {
        default: '#eac407',
        light: '#fefcf2',
    },
    shades: {
        black: '#0d2149',
        cement: '#333333',
        grey: '#b6bcc8',
        smoke: '#e6e8ec',
        whiteSmoke: '#f3f4f6',
        white: '#ffffff',
    },
    focus: {
        default: '0 0 0px 3px rgba(60, 138, 255, 0.358)',
    },
};
function setTheme(config, appId) {
    if (CSS.supports('(--primary: red)')) {
        Object.keys(config)
            .map(function (shade) {
            Object.keys(config[shade])
                .map(function (variation) {
                var selector = appId.length > 0 ?
                    document
                        .getElementById(appId)
                    :
                        document.documentElement;
                selector
                    .style
                    .setProperty("--" + shade + "-" + variation, config[shade][variation]);
            });
        });
    }
}
/**
 * theme engine for alchemy
 */
var AppTheme = /** @class */ (function () {
    function AppTheme() {
        this.appTheme = defaultTheme;
        this.appId = 'root';
    }
    Object.defineProperty(AppTheme.prototype, "theme", {
        get: function () {
            return this.appTheme;
        },
        set: function (theme) {
            this.appTheme = theme;
            this.init();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * extend from the default theme
     * @param theme
     */
    AppTheme.prototype.extend = function (theme) {
        this.theme = __assign(__assign({}, this.appTheme), theme);
        this.init();
    };
    /**
     * attach theme attributes to document
     * @default documentElement attaches to document rootNode
     * @param appId application id
     */
    AppTheme.prototype.init = function (appId) {
        if (appId === void 0) { appId = this.appId; }
        this.appId = appId;
        setTheme(this.appTheme, appId);
    };
    return AppTheme;
}());
var appTheme = new AppTheme();

/**
 * Renders select box
 * @extends DropDown from carbon
 * @type metal
 */
function selectBox(props) {
    var _a;
    var selectRef = React.useRef(null);
    var dropdownRef = React.useRef(null);
    var boundaryRef = React.useRef(null);
    var _b = React.useState(props.setDropDownOpen || false), dropDownOpenState = _b[0], setDropDownOpenState = _b[1];
    var _c = React.useState(0), currentIndex = _c[0], setCurrentIndex = _c[1];
    var _d = React.useState(false), canScroll = _d[0], setCanScroll = _d[1];
    var _e = React.useState(props.searchText || ''), searchText = _e[0], setSearchText = _e[1];
    var dropDownListLength = 0;
    var onClick = function () {
        if (dropDownOpenState) {
            hideDropDown();
        }
        else {
            showDropDown();
        }
    };
    var showDropDown = function () {
        setDropDownOpenState(true);
    };
    var hideDropDown = function () {
        setDropDownOpenState(false);
        selectRef.current.focus();
    };
    var onFocus = function (event) {
        if (props.onFocus)
            props.onFocus(event);
        setCanScroll(true);
    };
    var onBlur = function () {
        if (props.onBlur)
            props.onBlur();
    };
    var onKeyDown = function (event) {
        if (props.children.length === 0) {
            return;
        }
        setCanScroll(true);
        var index = currentIndex;
        var preventDefault = false;
        if (ariaKeyDown(event, [KEY_ENTER])) {
            if (!dropDownOpenState) {
                showDropDown();
                return;
            }
            var newValue = clonedChild[currentIndex].props.value;
            props.onChange(event, newValue);
            setTimeout(function () {
                hideDropDown();
            }, 300);
        }
        else if (ariaKeyDown(event, [KEY_UP])) {
            if (currentIndex - 1 >= 0) {
                index -= 1;
            }
            else {
                index = dropDownListLength;
            }
            preventDefault = true;
        }
        else if (ariaKeyDown(event, [KEY_DOWN])) {
            if (!dropDownOpenState) {
                showDropDown();
                return;
            }
            if (currentIndex + 1 <= dropDownListLength) {
                index += 1;
            }
            else {
                index = 0;
            }
            preventDefault = true;
        }
        else if (ariaKeyDown(event, [KEY_TAB, KEY_ESC])) {
            hideDropDown();
        }
        if (preventDefault)
            event.preventDefault();
        setCurrentIndex(index);
    };
    var outsideClickListener = function (event) {
        if (dropDownOpenState && dropdownRef.current) {
            if (!dropdownRef.current.contains(event.target)) {
                hideDropDown();
                removeClickListener();
            }
        }
    };
    var removeClickListener = function () {
        document.removeEventListener('click', outsideClickListener, false);
    };
    var onChildClick = function (event, index) {
        var newValue = clonedChild[index].props.value;
        props.onChange(event, newValue);
        setCurrentIndex(index);
        setTimeout(function () {
            hideDropDown();
        }, 300);
    };
    var onScroll = function () {
        setCanScroll(false);
    };
    var onSearchStringChange = function (event) {
        var value = event.target.value;
        setSearchText(value);
        if (props.enableSearchBox && props.onSearchValueChange) {
            props.onSearchValueChange(value);
            setCurrentIndex(0);
        }
    };
    React.useEffect(function () {
        document.addEventListener('click', outsideClickListener, false);
        return function () {
            removeClickListener();
        };
    });
    var clonedChild = React__default.Children.map(props.children, function (child, i) {
        var focus = i === currentIndex;
        return React__default.cloneElement(child, {
            tabIndex: focus ? 0 : -1,
            canFocus: focus,
            scrollTo: focus && canScroll,
            index: i,
            onClick: onChildClick,
        });
    });
    dropDownListLength = clonedChild.length - 1;
    return (React__default.createElement("div", { className: d_s.position_relative, ref: boundaryRef, onKeyDown: onKeyDown, onScroll: onScroll },
        React__default.createElement(row, { flexWidth: 12 },
            React__default.createElement(column, null,
                React__default.createElement(row, { height: "70px", flexWidth: 12 },
                    React__default.createElement("div", { id: props.id, onClick: onClick, tabIndex: 0, ref: selectRef, className: classnames([
                            sb_s.select,
                            d_s.display_flex,
                            d_s.display_flex__row,
                        ]), "aria-label": props.label, "aria-haspopup": "listbox", "aria-expanded": dropDownOpenState, onFocus: onFocus, onBlur: onBlur },
                        React__default.createElement(row, { flexWidth: 11 },
                            React__default.createElement("div", { className: g_s.width_1__1 }, props.selected)),
                        React__default.createElement(row, { flexWidth: 1, justifyContent: "flex-end" },
                            React__default.createElement("div", null,
                                React__default.createElement("img", { className: classnames([sb_s.icon], (_a = {},
                                        _a[sb_s.open] = dropDownOpenState,
                                        _a)), src: dropdownSvg, alt: "dropdown_icon" }))))),
                React__default.createElement(row, { height: "300px", flexWidth: 12 }, dropDownOpenState && (React__default.createElement(dropDown, { forwardRef: dropdownRef, left: 0 },
                    props.enableSearchBox && (React__default.createElement(input, { id: props.id + "_fb", label: "search " + props.name, name: props.name + "_name", value: searchText, type: "text", onChange: onSearchStringChange, placeHolder: "Search " + props.name, style: {
                            border: '5px solid white',
                            backgroundColor: appTheme.theme.primary.light,
                            width: '100%',
                            boxShadow: 'none',
                            borderRadius: 6,
                        }, autoFocus: true })),
                    clonedChild)))))));
}

var css$k = ".listBox-module_listBox__14xmQ {\n  padding: 5px;\n  margin: 0;\n  overflow-y: scroll;\n  border-radius: 6px;\n  border: 1px solid var(--shades-smoke);\n}\n\n.listBox-module_ghost__3m5Su {\n  border: none;\n}\n\n.listBox-module_ghost__3m5Su:focus {\n  box-shadow: none;\n}\n\n.listBox-module_listBox__14xmQ:focus {\n  box-shadow: var(--focus-default);\n  outline-width: 0;\n}";
var lb_s = {"listBox":"listBox-module_listBox__14xmQ","ghost":"listBox-module_ghost__3m5Su"};
styleInject(css$k);

/**
 * Renders select box
 * @extends ListItem|any
 * @type metal
 */
function listBox(props) {
    var _a;
    var _b = React.useState(0), currentIndex = _b[0], setCurrentIndex = _b[1];
    var _c = React.useState(false), showFocus = _c[0], setShowFocus = _c[1];
    var dropDownListLength = 0;
    var styleProps = {
        height: props.height || 300,
    };
    var onFocus = function (event) {
        if (props.onFocus)
            props.onFocus(event);
        setShowFocus(true);
    };
    var onBlur = function () {
        if (props.onBlur)
            props.onBlur();
        setShowFocus(false);
    };
    var onKeyDown = function (event) {
        var index = currentIndex > dropDownListLength ? 0 : currentIndex;
        var preventDefault = false;
        if (ariaKeyDown(event, [KEY_ENTER])) {
            if (clonedChild[currentIndex]) {
                var newValue = clonedChild[currentIndex].props.value;
                props.onInteract(event, newValue);
            }
            else {
                index = 0;
            }
        }
        else if (ariaKeyDown(event, [KEY_UP])) {
            if (currentIndex - 1 >= 0) {
                index -= 1;
            }
            else {
                index = dropDownListLength;
            }
            preventDefault = true;
        }
        else if (ariaKeyDown(event, [KEY_DOWN])) {
            if (currentIndex + 1 <= dropDownListLength) {
                index += 1;
            }
            else {
                index = 0;
            }
            preventDefault = true;
        }
        if (preventDefault)
            event.preventDefault();
        setCurrentIndex(index);
    };
    var onChildClick = function (event, index) {
        var newValue = clonedChild[index].props.value;
        props.onInteract(event, newValue);
        setCurrentIndex(index);
    };
    var clonedChild = React__default.Children.map(props.children, function (child, i) {
        var focus = i === currentIndex;
        return React__default.cloneElement(child, {
            tabIndex: focus ? 0 : -1,
            canFocus: props.hideChildFocusUnlessFocused === true ? showFocus && focus : focus,
            scrollTo: focus,
            index: i,
            onClick: onChildClick,
        });
    });
    dropDownListLength = clonedChild.length - 1;
    return (React__default.createElement("div", { id: props.id, className: classnames([lb_s.listBox], (_a = {}, _a[lb_s.ghost] = props.type === 'ghost', _a)), style: styleProps, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, tabIndex: 0, role: "listbox" }, clonedChild));
}

var _ref$1 =
/*#__PURE__*/
React__default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
});

var _ref2 =
/*#__PURE__*/
React__default.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
});

var closeIcon = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M19%206.41L17.59%205%2012%2010.59%206.41%205%205%206.41%2010.59%2012%205%2017.59%206.41%2019%2012%2013.41%2017.59%2019%2019%2017.59%2013.41%2012z%22%2F%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22%2F%3E%3C%2Fsvg%3E";

var css$l = ".modalFrame-module_modal_root__51VTt {\n  position: relative;\n  z-index: 10;\n}\n\n.modalFrame-module_modal__2u6JR {\n  z-index: 10;\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: modalFrame-module_bckgd__rKTq6 0.2s ease-in-out forwards;\n}\n\n\n@keyframes modalFrame-module_bckgd__rKTq6 {\n  from {\n    background-color: rgba(0, 0, 0, 0);\n  }\n  to {\n    background-color: rgba(255, 255, 255, 0.9);\n  }\n}\n";
var m_s = {"modal_root":"modalFrame-module_modal_root__51VTt","modal":"modalFrame-module_modal__2u6JR","bckgd":"modalFrame-module_bckgd__rKTq6"};
styleInject(css$l);

function modalFrame(props) {
    var modalRef = React.useRef(null);
    var onKeyDownHandler = function (event) {
        if (ariaKeyDown(event, [KEY_ESC])) {
            close();
        }
    };
    var onClickHandler = function (event) {
        if (ariaClick(event) && event.target === (modalRef.current)) {
            close();
        }
    };
    var close = function () {
        props.onClose();
    };
    if (props.closeOnEsc !== false) {
        document.addEventListener(KEYDOWN, onKeyDownHandler, false);
    }
    if (props.closeOnClickOut !== false) {
        document.addEventListener(CLICK, onClickHandler, false);
    }
    var removeAllListeners = function () {
        document.removeEventListener(KEYDOWN, onKeyDownHandler, false);
        document.removeEventListener(CLICK, onClickHandler, false);
    };
    React.useEffect(function () {
        if (props.closeOnEsc !== false) {
            document.addEventListener(KEYDOWN, onKeyDownHandler, false);
        }
        if (props.closeOnClickOut !== false) {
            document.addEventListener(CLICK, onClickHandler, false);
        }
        return function () { removeAllListeners(); };
    });
    return (React__default.createElement("div", { id: "#" + props.id + "-root", className: m_s.modal_root },
        React__default.createElement("div", { ref: modalRef, className: m_s.modal },
            React__default.createElement(modalContainer, { id: props.id, name: props.name, description: props.description, width: props.width, padding: props.padding || '5px 0' }, props.children),
            React__default.createElement("div", { style: {
                    position: 'absolute',
                    top: 50,
                    right: 50,
                } },
                React__default.createElement(column, { alignContent: "center" },
                    React__default.createElement(iconButton, { id: props.id + "-modal_close", name: "closeModal", ariaLabel: "close", accessKey: KEY_ESC, size: "normal", icon: closeIcon, onClick: close }),
                    props.closeOnEsc !== false && React__default.createElement("small", { className: s_s.margin_top__couple, style: { color: 'var(--shades-grey)' } }, "Esc"))))));
}

exports.InputBox = inputBox;
exports.TextButton = textButton;
exports.SelectBox = selectBox;
exports.ListBox = listBox;
exports.ModalFrame = modalFrame;
//# sourceMappingURL=index.js.map
